import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import * as wActs from "../actions/website-actions";
import {Link} from 'react-router-dom'
import EPomBanner from "../components/epombanner";
import * as wConsts from "../consts/website-consts";
import SwBanner from "../components/swbanner";
import BuyAdsBanner from "../components/buyadsbanner";


const lStyle = {border: "solid 1px #454545", display: "inline-block", padding: "3px", backgroundColor: "#000", margin: "2px", fontSize: "16px", lineHeight: "18px"}
const sectHdr = {background: "#761e8e", textAlign: "left", padding: "7px", marginTop: "10px", fontSize: "13px", marginBottom: "10px"}
const defHdr = {textAlign: "left", padding: "7px", marginTop: "2px", fontSize: "13px"}



class SiteMap extends Component {

  handleClick(e) {
    window.ScrollTop();
  }

  getPath(url) {
    let reg = /.+?\:\/\/.+?(\/.+?)?(?:#|\?|)?$/;
    let path = reg.exec(url)[1];
    if(wActs.isNullOrEmpty(path)) { path ="/" }
    return path;
  }

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "sitemap" });
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }


  render() {

    let list = this.props.SiteMap.Loaded && !wActs.isNullOrUndefined(this.props.SiteMap.ApiResult.Result) ?  this.props.SiteMap.ApiResult.Result : [];
    //console.log(list.Groups)
    return (
      <div className="sitemap-wrapper">
        <div className="container">

          {!this.props.SiteMap.Loaded &&
            <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
              <img src={`/imgs/${this.props.WebPage.Settings.ColorTheme.toLowerCase()}/loader.gif?v=12`} width={"100px"} height={"100px"} alt={"Loading"}/>
            </p>
          }
          {this.props.SiteMap.Loaded &&
            <div class="row">
              <div class="col-sm-8">
                <div className="sitemap-links">
                  {list.Groups.map((gv,gi) => {
                  return (
                    <React.Fragment key={"group-" + gi}>
                      <h5 className="col-lg-12">{gv.Title}</h5>
                      <ul>
                      {gv.Rows.map((rv,ri) => {
                        let title = rv.Title;
                        let out = [<li key={"row1-" + ri} className="col-sm-6" style={{display: "inline-block"}}><Link onClick={(e) => {this.handleClick(e)}} className={"sitemapLink"} title={rv.AltText} to={this.getPath(rv.Url)}>{title}</Link></li>];
                        if(rv.Rows) {
                          let sub = rv.Rows.map((rrv,rri)=> {
                            let title = rv.Title + " - " + rrv.Title;
                            return <li key={"row2-" + rri} className="col-sm-6" style={{display: "block"}}><Link onClick={(e) => {this.handleClick(e)}} className={"sitemapLink"} title={rrv.AltText} to={this.getPath(rrv.Url)}>{title}</Link></li>;
                          });
                          out = (
                            (
                              <React.Fragment key={"row3-" + ri}>
                                <li key={"row1-" + ri} className="col-sm-12" style={{display: "inline-block", marginTop: "20px"}}><Link onClick={(e) => {this.handleClick(e)}} className="sitemapLink" style={{fontSize: "25px"}} title={rv.AltText} to={this.getPath(rv.Url)}>{title}</Link></li>
                              <ul>
                                {sub}
                              </ul>
                              </React.Fragment>
                            ))
                        }
                        return out;
                      })}
                      </ul>
                    </React.Fragment>
                  );
                  }
                )}
                </div>
              </div>

              <div className="col-sm-4">
                <div className="promo-sidebar">
                  <div className="flex-center-vertical">
                    <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-200x200-sidebar']} className="opartners-list" >
                      <BuyAdsBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
                    </SwBanner>
                  </div>
                </div>
              </div>


            </div>
          }
        </div></div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    SiteMap: state.Website.SiteMap
  };
}

export default connect(mapStateToProps)(SiteMap);
